module.exports = __webpack_public_path__ + "img/logo.031c5d15.svg";